module.exports = __webpack_public_path__ + "img/JJ-pc-requirements.8f7b2572.png";